/* eslint-disable react/prop-types */
import React from 'react'
import Table from 'react-bootstrap/Table'
import { useTranslation } from 'react-i18next'

export const CartRender = ({ cartLocal }) => {
    const [t] = useTranslation("global")
    const country = process.env.REACT_APP_COUNTRY;

    return (
        <>
            <h1 style={{ textAlign: 'center' }}>Resumen de pedido</h1>
            <hr />
            <Table responsive className='tableCart'>
                <thead>
                    <tr>
                        <th>{t("cartRender.cantidad")}</th>
                        <th>{t("cartRender.descripcion")}</th>
                        <th>{t("cartRender.precio")}</th>
                        <th>{t("cartRender.precio-total")}</th>
                    </tr>
                </thead>
                <tbody>
                    {cartLocal.map(item => {
                        return (
                            <tr key={item.Nombre}>
                                <td>{item.contador}</td>
                                <td>{item.Nombre}</td>
                                <td>
                                    {country === "ARG" ?
                                        (item.Moneda_Signo ? `${item.Moneda_Signo} ${(item.Precio).toFixed(2)}` : `AR$ ${(item.Precio).toFixed(2)}`)
                                        : `U$S ${(item.Precio).toFixed(2)}`}
                                </td>
                                <td>
                                    {country === "ARG" ?
                                        (item.Moneda_Signo ? `${item.Moneda_Signo} ${(item.Precio * item.contador).toFixed(2)}` : `AR$ ${(item.Precio * item.contador).toFixed(2)}`)
                                        : `U$S ${(item.Precio * item.contador).toFixed(2)}`}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </>
    )
}